import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import Address from '../Address';
import { sizes } from '../../theme';
import * as style from './UnitDetailContent.module.scss';
import useUnitData from '../../hooks/UseUnitData';
import { useConfig } from '../../contexts/ConfigProvider';
import useWidthQuery from '../../hooks/UseWidth';
import { DESKTOP_WIDTH } from '../../theme/media';

const spacing = {
  whiteSpace: 'pre',
  display: 'inline-block',
};

const UnitDetailContent = ({ showOn = 'all' }) => {
  const isDesktop = useWidthQuery(DESKTOP_WIDTH);

  const shouldRender = showOn === 'all'
    || (showOn === 'mobile' && !isDesktop)
    || (showOn === 'desktop' && isDesktop);

  if (!shouldRender) {
    return null;
  }

  const {
    data: {
      unit: {
        amenities = [],
        size,
        inventory: { available, availableInTier },
        rates: { baseRate, effectiveRate },
      },
      facility: { address },
    },
  } = useUnitData();

  const {
    configuration: {
      providerConfig: { unitsAvailabilityCountDisplayThreshold },
    },
  } = useConfig();

  const availableCount = availableInTier || available;
  const unitCountThreshold = unitsAvailabilityCountDisplayThreshold !== undefined
    && availableCount > 0
    && availableCount <= Number(unitsAvailabilityCountDisplayThreshold);

  return (
    <Box
      sx={{
        border: '2px solid',
        borderColor: 'gray.lightBorder !important',
        borderRadius: 'md !important',
        padding: `${sizes._12px}`,
        marginBottom: `${sizes._12px}`,
      }}
    >
      <Text variant="smBold" color="gray.lightText" className={style.marginBottom}>
        UNIT DETAILS
      </Text>
      <Address address={address} className={style.marginBottom} />
      <Text variant="mdBold" className={style.marginBottom}>
        {size} Unit
      </Text>
      <Text variant="smLight" className={style.marginBottom}>
        {amenities.map(({ name }) => name).join(', ')}
      </Text>
      {unitCountThreshold && (
        <Text sx={{ ...spacing }} variant="lgLight" color="tertiary.accent">
          {`${availableCount} left at `}
        </Text>
      )}
      <Text sx={{ ...spacing }} variant="lgBold" color="tertiary.accent">
        {`$${parseFloat(effectiveRate) === 0 ? baseRate : effectiveRate} `}
      </Text>
      <Text sx={{ ...spacing }} variant="mdLight">
        {'per month '}
      </Text>
      {parseFloat(baseRate) > parseFloat(effectiveRate) && parseFloat(effectiveRate) !== 0 && (
        <Text
          sx={{
            ...spacing,
            textDecoration: 'line-through',
            display: 'block',
          }}
          variant="smLight"
          color="gray.lightText"
        >
          {`$${baseRate} `}
        </Text>
      )}
    </Box>
  );
};

export default UnitDetailContent;
